import React from 'react';
import PropTypes from 'prop-types';
import {NavbarLink} from './navbarLink';
import {NewPermissionGate} from '../../permissions/permissionGate';
import * as allConstants from '../../constants/allConstants';
import {urlSearchParams} from '../../baseUrls';
import {LinkWrapper} from './linkWrapper';
import {NavbarMenuButton} from './navbarMenuButton';
import {jobRules, IPERMIT_JOB_ELEMENTS} from '../../permissions/ipermitAccessControl/index';
import {productsPageRules, ACCOUNTING_ELEMENTS} from '../../permissions/accountingAccessControl';
import {tagsPageRules, TAG_ELEMENTS} from '../../permissions/tagAccessControl';
import {companyRules, COMPANY_ELEMENTS} from '../../permissions/companyAccessControl';
import {contractorUserPageRules, CONTRACTOR_ELEMENTS} from '../../permissions/contractorUserPageAccessControl';
import {contractorTagJobRules, CONTRACTOR_TAG_ELEMENTS} from '../../permissions/contractorTagJobAccessControl';
import {cityRules, CITY_ELEMENTS} from '../../permissions/cityAccessControl';
import {stateRules, STATE_ELEMENTS} from '../../permissions/stateAccessControl';
import {rebateRules, REBATE_ELEMENTS} from '../../permissions/rebateAccessControl';
import {ratersPageRules, RATER_ELEMENTS} from '../../permissions/raterPageAccessControl';
import {CONTRACTOR_JOB_ELEMENTS, contractorJobRules} from '../../permissions/jobsAccessControl';
import {ipermitAdminRules, ADMIN_ELEMENTS} from '../../permissions/ipermitAdminAccessControl';
import {canAdministerPartners} from '../../permissions/utils';

const AllLinks = (props)=> {
  const companyId = props.user?.companyId;

  let adminPanelLinks = [];

  if(NewPermissionGate({
    user: props.user,
    elementPermissions: stateRules[STATE_ELEMENTS.viewState]
  })) {
    adminPanelLinks.push({
      alt: 'States',
      text: 'All States',
      path: allConstants.PATH.STATES,
    });
  }
  if(NewPermissionGate({
    user: props.user,
    elementPermissions: rebateRules[REBATE_ELEMENTS.viewState]
  })) {
    adminPanelLinks.push({
      alt: 'Rebates',
      text: 'All Rebates',
      path: allConstants.PATH.REBATES,
    });
  }
  if(NewPermissionGate({
    user: props.user,
    elementPermissions: tagsPageRules[TAG_ELEMENTS.addTagButton]
  })) {
    adminPanelLinks.push({
      alt: 'tags',
      text: 'All iPermit Tags',
      path: allConstants.PATH.TAGS,
    });
  }
  if(NewPermissionGate({
    user: props.user,
    elementPermissions: ratersPageRules[RATER_ELEMENTS.viewPage]
  })) {
    adminPanelLinks.push({
      alt: 'raters',
      text: 'Raters',
      path: allConstants.PATH.RATERS,
    });
  }
  if(NewPermissionGate({
    user: props.user,
    elementPermissions: ipermitAdminRules[ADMIN_ELEMENTS.adminPanel]
  })) {
    adminPanelLinks.push({
      alt: 'users',
      text: 'iPermit Users',
      path: allConstants.PATH.ADMIN_PAGE,
    });
    adminPanelLinks.push({
      alt: 'analytics',
      text: 'Analytics',
      path: allConstants.PATH.ANALYTICS,
    });
    adminPanelLinks.push({
      alt: 'zoho logs',
      text: 'Zoho API Logs',
      path: allConstants.PATH.ZOHO_LOGS,
    });
  }

  // Narrower than the adminPanel block above, which admits every iPermit user.
  // The API behind this page is IPERMIT_ADMIN / SYSTEM_ADMIN only, so showing
  // it to anyone else was a link to a page of 403s.
  if(canAdministerPartners(props.user?.role)) {
    adminPanelLinks.push({
      alt: 'partner api',
      text: 'Partner API',
      path: allConstants.PATH.PARTNERS,
    });
  }

  if(props.showIpermitLinks){
    return (
      <>

        <NewPermissionGate user={props.user} elementPermissions={IPERMIT_JOB_ELEMENTS.viewPermits}>
          <LinkWrapper>
            <NavbarMenuButton buttonContent={'Permits'}
              drowdownWidth={'220px'}
              startIcon={{
                alt: 'permits',
                icon: 'two_pages'
              }}
              module={allConstants.IPERMIT_MODULES.PERMIT}
              links={[
                {
                  alt: 'permits',
                  text: 'All Jobs',
                  submodule: allConstants.IPERMIT_MODULES.ALL_JOBS,
                },
                {
                  alt: 'permits',
                  text: 'CF1R',
                  submodule: allConstants.IPERMIT_MODULES.CF1R,
                },
                {
                  alt: 'not synced to crm',
                  text: 'Not Synced to CRM',
                  submodule: allConstants.IPERMIT_MODULES.NOT_SYNCED_TO_CRM,
                },
              ]}
            >
            </NavbarMenuButton>
          </LinkWrapper>
        </NewPermissionGate>
        {/* <NewPermissionGate user={props.user} elementPermissions={jobRules[IPERMIT_JOB_ELEMENTS.viewInspections]}> */}
          <NavbarMenuButton buttonContent={'Inspections'}
              startIcon={{
                alt: 'inspections',
                icon: 'list'
              }}
              module={allConstants.IPERMIT_MODULES.INSPECTION}
              links={[
                {
                  alt: 'inspections',
                  text: 'Inspections',
                  path: `${allConstants.PATH.MODULE}?${urlSearchParams.moduleName}=${allConstants.IPERMIT_MODULES.INSPECTION}`
                },
                {
                  alt: 'calendar',
                  text: 'Calendar',
                  path: allConstants.PATH.INSPECTION_SCHEDULE,
                },
                // {
                //   alt: 'aicalls',
                //   text: 'AI Calls',
                //   path: allConstants.PATH.AI_CALLS,
                // },
                // {
                //   alt: 'my-aicalls',
                //   text: 'My AI Calls',
                //   path: allConstants.PATH.MY_AI_CALLS,
                // },
                {
                  alt: 'ai-dashboard',
                  text: 'AI Dashboard',
                  path: allConstants.PATH.AI_DASHBOARD,
                },
              ]}
            >
            </NavbarMenuButton>

        {/* </NewPermissionGate> */}
        {/* <NewPermissionGate user={props.user} elementPermissions={jobRules[IPERMIT_JOB_ELEMENTS.viewInspections]}>
          <LinkWrapper>
            <NavbarLink path={`${allConstants.PATH.MODULE}?${urlSearchParams.moduleName}=${allConstants.IPERMIT_MODULES.INSPECTION}`} alt={'inspections'} icon={'list'} text={'Inspections'}/>
          </LinkWrapper>
        </NewPermissionGate> */}

        <NewPermissionGate user={props.user} elementPermissions={companyRules[COMPANY_ELEMENTS.allCompaniesNavLink]}>
          <LinkWrapper>

            <NavbarMenuButton buttonContent={'Companies'}
              drowdownWidth={'200px'}
              startIcon={{
                alt: 'companies',
                icon: 'briefcase'
              }}
              module={allConstants.IPERMIT_MODULES.COMPANIES}
              links={[
                {
                  alt: 'companies',
                  text: 'All Companies',
                  path: allConstants.PATH.ALL_COMPANIES,
                },
                {
                  alt: 'users',
                  text: 'Contractor Users',
                  path: allConstants.PATH.USERS,
                },
                {
                  alt: 'contractor Tags',
                  text: 'All Contractor Tags',
                  path: allConstants.PATH.TAG_JOBS,
                },
                // {
                //   alt: 'schedule',
                //   text: 'Inspection Schedule',
                //   path: allConstants.PATH.INSPECTION_SCHEDULE,
                // }
              ]}
            >
            </NavbarMenuButton>

            {/*<NavbarLink alt={'all companies'} icon={'briefcase'}  text={'All Companies'} path={allConstants.PATH.ALL_COMPANIES}/>*/}
          </LinkWrapper>
        </NewPermissionGate>


        <NewPermissionGate user={props.user} elementPermissions={cityRules[CITY_ELEMENTS.viewCity]}>
          <LinkWrapper>
            <NavbarLink alt={'cities'}
              icon={'city'}
              text={'Cities'}
              path={allConstants.PATH.CITIES}/>
          </LinkWrapper>
        </NewPermissionGate>

        <NewPermissionGate user={props.user}
          elementPermissions={productsPageRules[ACCOUNTING_ELEMENTS.viewProducts]}>
          <LinkWrapper>
            <NavbarLink alt={'products'} icon={'products'} text={'Products'} path={allConstants.PATH.PRODUCTS}/>
          </LinkWrapper>
        </NewPermissionGate>
        {/* <NewPermissionGate user={props.user}
          elementPermissions={tagsPageRules[TAG_ELEMENTS.addTagButton]}>
          <LinkWrapper>
            <NavbarLink alt={'tags'} icon={'products'} text={'Tags'} path={allConstants.PATH.TAGS}/>
          </LinkWrapper>
        </NewPermissionGate>
        <NewPermissionGate user={props.user} elementPermissions={ratersPageRules[RATER_ELEMENTS.viewPage]}>
          <LinkWrapper>
            <NavbarLink alt={'Raters'} icon={'users'} text={'Raters'} path={allConstants.PATH.RATERS}/>
          </LinkWrapper>
        </NewPermissionGate> */}
        {/* <NewPermissionGate user={props.user} elementPermissions={companyRules[COMPANY_ELEMENTS.allCompaniesNavLink]}> */}
        {adminPanelLinks.length  > 0 &&  <LinkWrapper>
            <NavbarMenuButton buttonContent={'Admin Panel'}
              drowdownWidth={'200px'}
              startIcon={{
                alt: 'admin',
                icon: 'briefcase'
              }}
              module={allConstants.IPERMIT_MODULES.ADMIN}
              links={adminPanelLinks}
            >
            </NavbarMenuButton>
          </LinkWrapper>
        }
        {/* </NewPermissionGate> */}
        {/* <LinkWrapper>
          <NavbarLink alt={'analytics'}
            icon={'piechart'}
            text={'Analytics'}
            path={allConstants.PATH.ANALYTICS}/>
        </LinkWrapper> */}
      </>
    );
  }

  return (
    <>
      <NewPermissionGate user={props.user} elementPermissions={contractorJobRules[CONTRACTOR_JOB_ELEMENTS.createJob]}>
        <LinkWrapper>
          <NavbarLink alt={'create_job'} icon={'plus'} text={'Create job'} path={allConstants.PATH.CREATE_JOB}/>
        </LinkWrapper>
      </NewPermissionGate>
      <LinkWrapper>
        <NavbarLink alt={'job'} icon={'list'} text={'Jobs'} path={allConstants.PATH.JOBS}/>
      </LinkWrapper>
      {/* <LinkWrapper>
        <NavbarLink alt={'schedule'} icon={'list'} text={'Schedule'} path={allConstants.PATH.INSPECTION_SCHEDULE}/>
      </LinkWrapper> */}
      <LinkWrapper>
          <NavbarMenuButton buttonContent={'Inspections'}
            startIcon={{
              alt: 'inspections',
              icon: 'two_pages'
            }}
            module={allConstants.IPERMIT_MODULES.PERMIT}
            links={[
              {
                alt: 'permits',
                text: 'Inspections',
                //path={allConstants.PATH.JOBS}
                path: `${allConstants.PATH.MODULE}?${urlSearchParams.moduleName}=${allConstants.IPERMIT_MODULES.INSPECTION}`,
                submodule: allConstants.IPERMIT_MODULES.CONTRACTOR_JOBS,
              },
              {
                alt: 'caledar',
                text: 'Calendar',
                path: `${allConstants.PATH.MODULE}?${urlSearchParams.moduleName}=${allConstants.IPERMIT_MODULES.INSPECTION}`, 
                submodule: allConstants.IPERMIT_MODULES.SCHED_CALENDAR,
              },
            ]}
          >
          </NavbarMenuButton>
        </LinkWrapper>

        <NewPermissionGate user={props.user} elementPermissions={companyRules[COMPANY_ELEMENTS.companyNavLink]}>
        { props.parentCompanyId  &&
                    <LinkWrapper>

                    <NavbarMenuButton buttonContent={'Companies'}
                      drowdownWidth={'200px'}
                      startIcon={{
                        alt: 'companies',
                        icon: 'briefcase'
                      }}
                      module={allConstants.IPERMIT_MODULES.COMPANIES}
                      links={[
                        {
                          alt: 'companies',
                          text: 'All Companies',
                          path: allConstants.PATH.ALL_COMPANIES,
                        },
                        {
                          alt: 'users',
                          text: 'Contractor Users',
                          path: allConstants.PATH.USERS,
                        },
                        // {
                        //   alt: 'schedule',
                        //   text: 'Inspection Schedule',
                        //   path: allConstants.PATH.INSPECTION_SCHEDULE,
                        // }
                      ]}
                    >
                    </NavbarMenuButton>
        
                    {/*<NavbarLink alt={'all companies'} icon={'briefcase'}  text={'All Companies'} path={allConstants.PATH.ALL_COMPANIES}/>*/}
                  </LinkWrapper>        
        }
        {!props.parentCompanyId  &&
          <LinkWrapper>
            <NavbarLink alt={'company'} icon={'briefcase'}  text={'Company'}
              path={companyId ? `${allConstants.PATH.COMPANY}?${urlSearchParams.companyId}=${companyId}`: allConstants.PATH.COMPANY}
            />
          </LinkWrapper>
        }
      </NewPermissionGate>
      {!props.parentCompanyId  &&
      <NewPermissionGate user={props.user}
        elementPermissions={contractorUserPageRules[CONTRACTOR_ELEMENTS.viewPage]}
      >
        <LinkWrapper>
          <NavbarLink alt={'users'} icon={'users'} text={'Users'} path={allConstants.PATH.USERS}/>
        </LinkWrapper>
      </NewPermissionGate>
      }
      {/* No parentCompanyId guard: that flag is set when the company HAS sub-accounts, so
          guarding on it hid Contractor Tags from exactly the prime company admins. */}
      <NewPermissionGate user={props.user}
        elementPermissions={contractorTagJobRules[CONTRACTOR_TAG_ELEMENTS.viewPage]}
      >
        <LinkWrapper>
          <NavbarLink alt={'Contractor Tags'} icon={'list'} text={'Contractor Tags'} path={allConstants.PATH.TAG_JOBS}/>
        </LinkWrapper>
      </NewPermissionGate>
      <LinkWrapper>
        <NavbarMenuButton
          buttonContent={'Analytics'}
          drowdownWidth={'250px'}
          module={''}
          startIcon={{
            alt: 'analytics',
            icon: 'piechart'
          }}
          links={[
            // {
            //   alt: 'analytics',
            //   text: 'Analytics',
            //   path: allConstants.PATH.ANALYTICS,
            // },
            {
              alt: 'permit status',
              text: 'Permit Analytics',
              path: allConstants.PATH.PERMIT_JOB_ANALYTICS,
            },
            {
              alt: 'permit weekly status',
              text: 'Permit Weekly Analytics',
              path: allConstants.PATH.PERMIT_JOB_WEEKLY_ANALYTICS,
            },
            {
              alt: 'inspection status',
              text: 'Inspection Analytics',
              path: allConstants.PATH.INSPECTION_ANALYTICS,
            },
            {
              alt: 'inspection weekly status',
              text: 'Inspection Weekly Analytics',
              path: allConstants.PATH.INSPECTION_WEEKLY_ANALYTICS,
            },
          ]}
        >
        </NavbarMenuButton>
      </LinkWrapper>
      {/*</PermissionGate>*/}


    </>
  );
};

AllLinks.propTypes = {
  user: PropTypes.shape({
    role: PropTypes.string,
    companyId: PropTypes.string,
  }),
  companyId: PropTypes.string,
  showIpermitLinks: PropTypes.bool,
};
AllLinks.defaultProps = {
  user: {
    role: allConstants.ROLES.CONTRACTOR,
    companyId: null,
  },
  showIpermitLinks: false,
};

export {AllLinks};
